import React, { ReactNode } from 'react';
import toast from '@/components/ui/toast/toast';
import { Notification } from '@/components/ui/Notification';

export const triggerErrorMessage = (msg: string | ReactNode = '') => {
  toast.push(
    <Notification type="danger" duration={2000}>
      {msg || 'Upload Failed!'}
    </Notification>,
    {
      placement: 'bottom-end',
    },
  )
}

export const triggerSuccessMessage = (msg: string | ReactNode = '') => {
  toast.push(
    <Notification type="success" duration={3000}>
      {msg || 'Success!'}
    </Notification>,
    {
      placement: 'bottom-end',
    },
  )
}

export const triggerInfoMessage = (msg: string | ReactNode = '') => {
  toast.push(
    <Notification type="info" duration={6000}>
      {msg}
    </Notification>,
    {
      placement: 'bottom-end',
    },
  )
}

